import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isCoachOpen: boolean;
  newBillSettlementState: Record<string, any>;
}

const initialState: StateInterface = {
  isCoachOpen: false,
  newBillSettlementState: {},
};

export const coachReducer = (
  state: StateInterface = initialState,
  action: ActionInterface
): StateInterface => {
  switch (action.type) {
    case Constants.COACH_TOGGLE:
      return {
        ...state,
        isCoachOpen: !state.isCoachOpen,
      };

    case Constants.SET_NEW_BILL_SETTLEMENT_STATE:
      return {
        ...state,
        newBillSettlementState: action.payload || {},
      };

    default:
      return state;
  }
};
